import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { NewsArticle } from './news-article.model';
import { NewsArticleService } from './news-article.service';
@Injectable()
export class NewsArticlePopupService {
    private isOpen = false;
    constructor (
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private newsArticleService: NewsArticleService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.newsArticleService.find(id).subscribe(newsArticle => {
                newsArticle.validSince = this.datePipe
                    .transform(newsArticle.validSince, 'yyyy-MM-ddThh:mm');
                newsArticle.validUntil = this.datePipe
                    .transform(newsArticle.validUntil, 'yyyy-MM-ddThh:mm');
                this.newsArticleModalRef(component, newsArticle);
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.newsArticleModalRef(component, new NewsArticle());
            });
        }
    }

    newsArticleModalRef(component: Component, newsArticle: NewsArticle): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.newsArticle = newsArticle;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article-popup.service.ts